var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"sticky-footer bg-white"},[_c('div',{staticClass:"container my-auto"},[_c('div',{staticClass:"copyright text-center my-auto"},[_c('span',[_vm._v("Copyright © PROJECİ BUL "+_vm._s(new Date().getFullYear()))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }